<template>
  <div class="container">
    <div class="index-view-router-link">
      <RouterLink :to="{ name: 'vn' }">
        VN Player
      </RouterLink>
    </div>
    <div class="index-view-router-link">
      <RouterLink :to="{ name: 'episodes' }">
        Episodes
      </RouterLink>
    </div>
    <div class="index-view-router-link">
      <RouterLink :to="{ name: 'control' }">
        Control Panel
      </RouterLink>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
// pass
</script>
